import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../hook/use-search-params";
import { StatisticsEmployeeService } from "../../../services/department-viags/statistics-employee.service";
import moment from "moment";
import { isDateInRange } from "../../../helper/dateTimeHelper";
import { useMemo } from "react";
import { useUser } from "../../../hook";

export const useDocsOfUser = () => {
  const { searchParams } = useSearchParams();
  const { email } = useUser();
  const empCode = searchParams.get("empCode") ?? email;
  const start = searchParams.get("start") ?? "";
  const end = searchParams.get("end") ?? "";

  const { data, isLoading } = useQuery({
    queryKey: ["docs-user", empCode],
    queryFn: () => StatisticsEmployeeService.getDocOfUser(empCode),
    enabled: !!empCode,
  });

  const filteredData = useMemo(() => {
    if (!start || !end) return data;

    return data?.filter((e) => {
      const publishDay = moment(e.publishDay);
      return isDateInRange(publishDay, moment(start), moment(end));
    });
  }, [data, end, start]);

  const countReadDocument = filteredData?.filter((e) => e.seen).length;
  const countUnReadDocument = filteredData?.filter((e) => !e.seen).length;
  const countTotalDocument = filteredData?.length;

  const countInternalDocument = filteredData?.filter((e) => e.docType === "Nội bộ").length;
  const countExternalDocument = filteredData?.filter((e) => e.docType === "Bên ngoài").length;
  const countPublishedDocument = filteredData?.filter(
    (e) => e.docStatus === "Ban hành" || e.docStatus === "Ban hành tạm thời",
  ).length;

  return {
    isLoading,
    filteredData,
    countReadDocument,
    countUnReadDocument,
    countTotalDocument,
    countInternalDocument,
    countExternalDocument,
    countPublishedDocument,
  };
};
